import { MessageSquare, Users as UsersIcon } from "lucide-react";
import { useChat } from "@/context/ChatContext";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import { PublicChat } from "@/components/chat/PublicChat";
import { DmPanel } from "@/components/chat/DmPanel";

export function ChatDrawer() {
  const { open, setOpen, tab, setTab } = useChat();
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent side="right" className="w-full sm:max-w-md p-0 bg-[#0A0E1A]/95 backdrop-blur-xl border-slate-800 text-slate-100 flex flex-col" data-testid="chat-drawer">
        <SheetHeader className="px-5 pt-5 pb-3 border-b border-slate-800">
          <SheetTitle className="font-display text-slate-50 flex items-center gap-2"><MessageSquare className="h-4 w-4 text-cyan-400" /> COREXE Sohbet</SheetTitle>
          <SheetDescription className="text-slate-500 text-xs">Kayıtlı herkes genel sohbette yazışabilir. Bir kullanıcıya tıklayıp özel sohbet isteği gönderebilirsin.</SheetDescription>
          <div className="grid grid-cols-2 gap-1 p-1 rounded-xl bg-slate-950/70 border border-slate-800 mt-3">
            <button data-testid="chat-tab-public" onClick={() => setTab("public")} className={`h-9 rounded-lg text-xs font-semibold inline-flex items-center justify-center gap-2 transition-colors ${tab === "public" ? "bg-slate-800 text-cyan-300" : "text-slate-400 hover:text-slate-200"}`}>
              <UsersIcon className="h-3.5 w-3.5" /> Genel Sohbet
            </button>
            <button data-testid="chat-tab-dm" onClick={() => setTab("dm")} className={`h-9 rounded-lg text-xs font-semibold inline-flex items-center justify-center gap-2 transition-colors ${tab === "dm" ? "bg-slate-800 text-cyan-300" : "text-slate-400 hover:text-slate-200"}`}>
              <MessageSquare className="h-3.5 w-3.5" /> Özel Mesajlar
            </button>
          </div>
        </SheetHeader>
        <div className="flex-1 min-h-0 flex flex-col">
          {tab === "public" ? <PublicChat /> : <DmPanel />}
        </div>
      </SheetContent>
    </Sheet>
  );
}
